import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function blogReducer(state = initialState.blogState, action) {
    switch(action.type) {
        case types.GET_BLOG_GENERAL:   
        {        
            const items = [...state.general.items].concat(action.results.items);
            const results = {...action.results, items};
            return {
                ...state,
                general: { ...state.general, ...results}
            };
        }
        case types.GET_BLOG_GENERAL_STATUS:
        {
            return {
                ...state,
                general: {...state.general, loadingStatus: action.loadingStatus}
            };
        }
        case types.CLEAR_BLOG_GENERAL:   
        {        
            return {
                ...state,
                general: { ...state.general, loadingStatus: null, items: [], selectedSections: [], selectedTags: [], lastPage: 0, haveNextPage: false}
            };
        }
        case types.GET_BLOG_UNSIGNED:   
        {        
            const items = [...state.unsigned.items].concat(action.results.items);
            const results = {...action.results, items};
            return {
                ...state,
                unsigned: { ...state.unsigned, ...results}
            };
        }
        case types.GET_BLOG_UNSIGNED_STATUS:
        {
            return {
                ...state,
                unsigned: {...state.unsigned, loadingStatus: action.loadingStatus}
            };
        }
        case types.CLEAR_BLOG_UNSIGNED:   
        {        
            return {
                ...state,
                unsigned: { ...state.unsigned, loadingStatus: null, items: [], selectedSections: [], selectedTags: [], lastPage: 0, haveNextPage: false}
            };
        }
        case types.GET_BLOG_DISCOVER:   
        {        
            const items = [...state.discover.items].concat(action.results.items);
            const results = {...action.results, items}
            return {
                ...state,
                discover: { ...state.discover, ...results}
            };
        }
        case types.GET_BLOG_DISCOVER_STATUS:
        {
            return {
                ...state,
                discover: {...state.discover, loadingStatus: action.loadingStatus}
            };
        }
        case types.CLEAR_BLOG_DISCOVER:   
        {        
            return {
                ...state,
                discover: { ...state.discover, loadingStatus: null, items: [], selectedSections: [], selectedTags: [], lastPage: 0, haveNextPage: false}
            };
        }
        case types.GET_BLOG_SECTIONS_GENERAL:   
        {        
            const results = {...action.results, sections: action.sections};
            return {
                ...state,
                general: { ...state.general, ...results}
            };
        }
        case types.GET_BLOG_TAGS_GENERAL:   
        {        
            const results = {...action.results, tags: action.tags};
            return {
                ...state,
                general: { ...state.general, ...results}
            };
        }
        case types.GET_BLOG_SECTIONS_UNSIGNED:   
        {        
            const results = {...action.results, sections: action.sections};
            return {
                ...state,
                unsigned: { ...state.unsigned, ...results}
            };
        }
        case types.GET_BLOG_TAGS_UNSIGNED:   
        {        
            const results = {...action.results, tags: action.tags};
            return {
                ...state,
                unsigned: { ...state.unsigned, ...results}
            };
        }
        case types.GET_BLOG_SECTIONS_DISCOVER:   
        {        
            const results = {...action.results, sections: action.sections};
            return {
                ...state,
                discover: { ...state.discover, ...results}
            };
        }
        case types.GET_BLOG_TAGS_DISCOVER:   
        {        
            const results = {...action.results, tags: action.tags};
            return {
                ...state,
                discover: { ...state.discover, ...results}
            };
        }
        case types.GET_ARTICLE:   
        {  
            return {
                ...state,
                article: action.article
            };
        }
        case types.GET_ARTICLE_STATUS:
        {
            return {
                ...state,
                articleLoadingStatus: action.loadingStatus
            };
        }
        case types.GET_ARTICLE_SHARES:
        {
            let article = state.article;
            if(article && state.article.Link === action.shares.link) {
                article = { ...article, ShareCount: action.shares.shareCount };
            }
            return {
                ...state,
                article
            };
        }
        default:
            return state;
    }
}